import { Component, input } from '@angular/core';

/**
 * The check that confirms mails filed just now. Partial, where only some of
 * the mails were filed, it shows in the colours of a warning, and the subtitle
 * says why. The title alone confirms a full success.
 */
@Component({
  selector: 'cmi-filed-heading',
  templateUrl: './filed-heading.html',
  host: { class: 'flex flex-col items-center gap-4 text-center' }
})
export class FiledHeading {
  public readonly title = input.required<string>();
  public readonly subtitle = input<string>();
  public readonly partial = input<boolean>(false);
}
